// extracted by mini-css-extract-plugin
module.exports = {"overlayClass":"AiItemTool_overlayClass__Gs7p1","smallBtn":"AiItemTool_smallBtn__AczvE"};